export default __webpack_public_path__ + "static/mastermatchmaker_screen_2-ad2d04689e4a9edeac9ab53e81dcdd87.svg";